export default __webpack_public_path__ + "static/city-and-guilds-2a9438f01a420f4d43f7860d2ef7bba7.png";